import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Grid, SvgIcon, Tooltip } from '@material-ui/core';
import { DiJsBadge, DiHaskell, DiPostgresql } from 'react-icons/di';
import { FaDocker, FaNodeJs, FaNpm, FaAngular, FaReact, FaPython, FaHtml5, FaCss3Alt, FaBootstrap, FaJava } from 'react-icons/fa';
import { AiOutlineCode } from 'react-icons/ai';
import uuid from 'uuid/v1';
import { Card, CardContent, CardActions, Typography, CardActionArea, CardMedia, Button } from '@material-ui/core';


const useStyles = makeStyles({
  card: {
    maxWidth: '100%',
  },
  fade: {
    position: 'absolute',
    bottom: 0,
    display: 'block',
    width: '100%',
    height: 50,
    backgroundImage: 'linear-gradient(to bottom, rgba(255, 255, 255, 0.0), rgba(255, 255, 255, 0.9) 60%)'
  }
});

const showIcon = (icon) => {
  if (icon && icon === 'DiJsBadge')
    return (<Tooltip title="JavaScript" key={uuid()} placement="top"><div><DiJsBadge key={uuid()} style={{ color: '#F1DE4F', width: 25, height: 'auto', borderRadius: 3, }} /></div></Tooltip>)
  if (icon && icon === 'DiPostgresql')
    return (<Tooltip title="PostgreSQL" key={uuid()} placement="top"><div><DiPostgresql key={uuid()} style={{ color: '#316192', width: 25, height: 'auto', borderRadius: 3, marginLeft: 10 }} /></div></Tooltip>)
  if (icon && icon === 'FaNodeJs')
    return (<Tooltip title="Node.js" key={uuid()} placement="top"><div><FaNodeJs key={uuid()} style={{ color: '#54B689', width: 25, height: 'auto', borderRadius: 3, marginLeft: 10 }} /></div></Tooltip>)
  if (icon && icon === 'FaNpm')
    return (<Tooltip title="npm" key={uuid()} placement="top"><div><FaNpm key={uuid()} style={{ color: '#BB443E', width: 25, height: 'auto', borderRadius: 3, marginLeft: 12 }} /></div></Tooltip>)
  if (icon && icon === 'AiOutlineCode')
    return (<Tooltip title="C/C++" key={uuid()} placement="top"><div><AiOutlineCode key={uuid()} style={{ color: '#797cea', width: 25, height: 'auto', borderRadius: 3 }} /></div></Tooltip>)
  if (icon && icon === 'FaAngular')
    return (<Tooltip title="Angular" key={uuid()} placement="top"><div><FaAngular key={uuid()} style={{ color: '#CA3327', width: 25, height: 'auto', borderRadius: 3, marginLeft: 10 }} /></div></Tooltip>)
  if (icon && icon === 'FaReact')
    return (<Tooltip title="React" key={uuid()} placement="top"><div><FaReact key={uuid()} style={{ color: '#62D4FA', width: 25, height: 'auto', borderRadius: 3, marginLeft: 10 }} /></div></Tooltip>)
  if (icon && icon === 'FaPython')
    return (<Tooltip title="Python" key={uuid()} placement="top"><div><FaPython key={uuid()} style={{ color: '#356a98', width: 25, height: 'auto', borderRadius: 3 }} /></div></Tooltip>)
  if (icon && icon === 'FaHtml5')
    return (<Tooltip title="Html" key={uuid()} placement="top"><div><FaHtml5 key={uuid()} style={{ color: '#EA6228', width: 25, height: 'auto', borderRadius: 3 }} /></div></Tooltip>)
  if (icon && icon === 'FaCss3Alt')
    return (<Tooltip title="CSS" key={uuid()} placement="top"><div><FaCss3Alt key={uuid()} style={{ color: '#3596D0', width: 25, height: 'auto', borderRadius: 3, marginLeft: 10 }} /></div></Tooltip>)
  if (icon && icon === 'DiHaskell')
    return (<Tooltip title="Haskell" key={uuid()} placement="top"><div><DiHaskell key={uuid()} style={{ color: '#5E5086', width: 30, height: 'auto', borderRadius: 3, marginTop: -4 }} /></div></Tooltip>)
  if (icon && icon === 'FaBootstrap')
    return (<Tooltip title="Bootstrap" key={uuid()} placement="top"><div><FaBootstrap key={uuid()} style={{ color: '#5E5086', width: 30, height: 'auto', borderRadius: 3 }} /></div></Tooltip>)
  if (icon && icon === 'FaDocker')
    return (<Tooltip title="Docker" key={uuid()} placement="top"><div><FaDocker key={uuid()} style={{ color: '#2496ED', width: 25, height: 'auto', borderRadius: 3, marginLeft: 12 }} /></div></Tooltip>)
  if (icon && icon === 'FaJava')
    return (<Tooltip title="Java" key={uuid()} placement="top"><div><FaJava key={uuid()} style={{ color: '#db861e', width: 25, height: 'auto', borderRadius: 3, marginLeft: 12 }} /></div></Tooltip>)
  if (icon && icon === 'MaterialUi')
    return (
      <SvgIcon key={uuid()} style={{ color: '#5E5086', width: 30, height: 'auto', borderRadius: 3 }}>
        {/* <path viewBox="0 0 9 10" d="m0 259.8v-259.8l225 129.9v86.6l-150-86.6v173.2z" fill="#00b0ff"/><path d="m225 129.9 225-129.9v259.8l-150 86.6-75-43.3 150-86.6v-86.6l-150 86.6z" fill="#0081cb"/><path d="m225 303.1v86.6l150 86.6v-86.6z" fill="#00b0ff"/><path d="m375 476.3 225-129.9v-173.2l-75 43.3v86.6l-150 86.6zm150-346.4v-86.6l75-43.3v86.6z" fill="#0081cb"/> */}
      </SvgIcon>)

}

const Project = props => {
  var { project } = props;
  const classes = useStyles()
  return (
    <Card className={classes.card}>
      <CardActionArea href={project.url}>
        <CardMedia
          component="img"
          alt={project.alt}
          height="140"
          image={project.imageUrl}
        />
        <CardContent>
          <Typography gutterBottom variant="h5" component="h2">
            {project.title}
          </Typography>
          <Typography variant="body2" style={{ height: '17vh', overflowY: 'hidden' }} color="textSecondary" component="p">
            {project.description}
            <span className={classes.fade}></span>
          </Typography>
        </CardContent>
      </CardActionArea>
      <CardActions>
        <Button size="small" color="primary" href={project.url}>
          Learn More
        </Button>
        <Grid container style={{ justifyContent: 'flex-end', width: '60%' }}>
          {project.icons.map(icon => showIcon(icon))}
        </Grid>
      </CardActions>
    </Card>
  );
};

Project.propTypes = {
  project: PropTypes.object.isRequired
};

export default Project;